<script setup lang="ts">
const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false
  },
  loadingMessage: {
    type: String,
    default: ""
  }
});
</script>

<template>
  <transition name="fade">
    <div v-if="props.isLoading" class="page-loader">
      <div class="loader-text">
        <div class="loader"></div>
        <p style="margin: 60px 0 0 21px">{{ props.loadingMessage }}</p>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.page-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
}

.loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--mds_brand_appearance_primary_default_background-color);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  position: absolute;
  left: 50%;
  top: 20%;
}

.loader-text {
  display: flex;
  position: absolute;
  z-index: 1;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 500;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
